import axios, { AxiosInstance } from 'axios'
import NProgress from 'nprogress'

export default (): AxiosInstance => {
  // create axios instance
  const instance = axios.create({
    //baseURL: process.env.VUE_APP_API_BASE_PATH,
    baseURL: import.meta.env.VITE_API_BASE_URL,
    timeout: 5000,
    // validateStatus: () => false
  })

  // add interceptors
  instance.interceptors.request.use((config) => {
    NProgress.start()
    return config
  })

  instance.interceptors.response.use((response) => {
    NProgress.done()
    return response
  })

  // return instance
  return instance
}
